// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"831da419","453":"5c2dd0b1","796":"1d71f162"}[chunkId] + ".chunk.js";
};